import { FormControl } from 'bold-ui'
import { MultiSelectFieldProps, SelectField, selectFieldStatus } from 'components/form'
import { ParteBucalEnum } from 'graphql/types.generated'

import { getParteBucal } from '../../../util-EvolucoesOdontologicasPlano'

export type ReplicarItemSelectFieldModel = {
  title: string
  value: ParteBucalEnum
}

export type ReplicarItemSelectFieldProps = DistributiveOmit<
  MultiSelectFieldProps<ReplicarItemSelectFieldModel>,
  'itemToString' | 'itemIsEqual' | 'multiple'
> & {
  label: string
  itemsDisabled?: ParteBucalEnum[]
  disabledCustomText?: (item: ReplicarItemSelectFieldModel) => string
}

export default function ReplicarItemSelectField(props: ReplicarItemSelectFieldProps) {
  const { name, label, items, itemsDisabled, disabledCustomText = () => 'Já possui dados', ...rest } = props

  const itemIsDisabled = (item: ReplicarItemSelectFieldModel) => itemsDisabled?.includes(item.value)

  return (
    <FormControl label={label}>
      <SelectField<ReplicarItemSelectFieldModel>
        name={name}
        multiple
        items={items}
        itemToString={(item) => item && getParteBucal(item.value).title.replace(' - ', ' ')}
        itemIsEqual={(a, b) => a.value === b.value}
        itemIsDisabled={itemIsDisabled}
        customText={disabledCustomText}
        selectedItemStyle={selectFieldStatus.INFO}
        {...rest}
      />
    </FormControl>
  )
}

export const convertParteBucalEnumToReplicarItem = (partesBucal: ParteBucalEnum[]) =>
  partesBucal?.map(
    (parteBucal) =>
      ({
        title: getParteBucal(parteBucal).title,
        value: parteBucal,
      } as ReplicarItemSelectFieldModel)
  )

export const convertReplicarItemToParteBucalEnum = (replicarItems: ReplicarItemSelectFieldModel[]) =>
  replicarItems && replicarItems.map((item) => item.value)
